import { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { INITIAL_LOGIN_PATTERN } from '@/constants/auth';
import { ROUTE_PATH } from '@/constants/routes';

export const RenewalNotice = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  // location.stateからemailとinitial_login_patternを取得（前画面から渡される想定）
  const state = location.state as { email?: string; initial_login_pattern?: string };
  const email = state?.email;
  const initialLoginPattern = state?.initial_login_pattern;

  // 遷移元でデータがセットされていない場合は想定フローではないのでログイン画面に戻す
  useEffect(() => {
    if (!email) {
      navigate(ROUTE_PATH.LOGIN);
    }
  }, [email, navigate]);

  if (!email) return null;

  const handleNext = () => {
    navigate(ROUTE_PATH.PASSWORD_SETTING_CONFIRM, { state: { email } });
  };

  return (
    <div className="page p-auth page_a2">
      <main className="page__main">
        <div className="page__content">
          <section className="l-section">
            <div className="l-section__line">
              <div className="l-container">
                <div className="l-hero">
                  <img
                    className="l-hero__img"
                    src="/Common_Title.jpg"
                    alt="LOUNGE RESERVATION"
                  />
                </div>

                <div className="l-grid">
                  <section className="l-card">
                    <h2 className="l-card__title">
                      <Trans
                        i18nKey="renewalNotice.title"
                        components={{ br: <br /> }}
                      />
                    </h2>
                    {/* 利用規約未同意の場合のみエラーメッセージ表示 */}
                    {initialLoginPattern === INITIAL_LOGIN_PATTERN.TERMS_NOT_ACCEPTED && (
                      <div className="c-auth__alerts">
                        <p className="c-auth__alert c-auth__alert--error">
                          {t('renewalNotice.termsNotAcceptedMessage')}
                        </p>
                      </div>
                    )}
                    <div className="l-card__body l-pt0">
                      <div className="l-text-group l-text-group--white">
                        <p className="l-text">
                          <Trans
                            i18nKey="renewalNotice.description"
                            components={{ br: <br /> }}
                          />
                        </p>
                      </div>
                      <div className="actions">
                        <a
                          onClick={handleNext}
                          className="link-button link-button--next"
                        >
                          {t('common.btn.next')}
                        </a>
                      </div>
                      <div className="l-text-group l-text-group--white">
                        <h3 className="l-card__subtitle">
                          {t('renewalNotice.aboutAccount.title')}
                        </h3>
                        <p className="l-text">
                          <Trans
                            i18nKey="renewalNotice.aboutAccount.description"
                            components={{ br: <br /> }}
                          />
                        </p>
                      </div>
                      <div className="l-box l-box--account">
                        <div className="l-box__lead">
                          <Trans
                            i18nKey="renewalNotice.bitkeyAccount.lead"
                            components={{ br: <br /> }}
                          />
                        </div>
                        <div className="l-box__link">
                          <a
                            href={t('common.links.workhub.about')}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="l-box__link-text"
                          >
                            {t('renewalNotice.bitkeyAccount.linkText')}
                          </a>
                        </div>
                        <div className="l-box__image">
                          <img
                            src="/Common_Related_Services02.png"
                            alt={t('renewalNotice.bitkeyAccount.imageAlt')}
                            className="l-box__image-img"
                          />
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
  );
};
